import viswaviratLogo from "@/assets/viswavirat-logo.png";

export default function ParentCompanyCredit() {
  return (
    <div data-parent-company-credit className="flex max-w-full items-center gap-3">
      <img
        src={viswaviratLogo}
        alt=""
        width={329}
        height={274}
        loading="lazy"
        decoding="async"
        className="h-auto w-14 shrink-0 object-contain sm:w-16"
      />
      <div className="min-w-0 text-left">
        <p className="text-[10px] font-semibold uppercase leading-4 tracking-[0.18em] text-[#8b652e]">
          Powered by
        </p>
        <p className="mt-0.5 text-base font-semibold leading-6 text-[#17243a]">
          ViswaVirat
        </p>
        <p className="max-w-[15rem] text-[11px] leading-5 text-muted-foreground sm:text-xs">
          Corporate Services Private Limited
        </p>
      </div>
    </div>
  );
}
